import React, { memo } from 'react';

import { useMutateEditSectorsSettings } from '@hooks/sectors/useMutateEditSectorsSettings';

import { ISectorSettingDTO } from '@interfaces/map/dto/sectorsDTO';

import SectorsSettingsForm, { ISectorsSettingsProps } from '../SectorsSettingsForm/SectorsSettingsForm';

export interface IUpdateSectorSettingsProps extends ISectorsSettingsProps {
	editingItem: ISectorSettingDTO;
}

function EditSectorSettingsForm(props: IUpdateSectorSettingsProps) {
	const { editingItem } = props;

	const {
		updateSectorsSettings,
		isUpdatingSectorSettings,
	} = useMutateEditSectorsSettings(editingItem.id, props.closeModal);

	return (
		<SectorsSettingsForm
			closeModal={props.closeModal}
			currentVendor={props.currentVendor}
			editingItem={props.editingItem}
			existingSectorSettings={props.existingSectorSettings}
			isLoading={isUpdatingSectorSettings}
			setIsDirtyFormModal={props.setIsDirtyFormModal}
			submitHandler={updateSectorsSettings}
		/>
	);
}

export default memo(EditSectorSettingsForm);
